<div class="header-container">
  <div class="header-content">
    <button nz-button nzType="link" [routerLink]="backLink">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
    </button>
    <h2 class="title">{{ title }}</h2>
  </div>
</div>
